import {defaultContentOptions} from '../constants';
import {DIVIDER} from '../../select';
import {TableauContentOptions} from './types';

export const WORKBOOKS_LIMIT = 100;

export const ACTION_TYPES = {
  WORKBOOK_PDF: 'workbook_pdf',
  WORKBOOK_POWERPOINT: 'workbook_powerpoint',
  VIEW_PDF: 'view_pdf',
  VIEW_CSV: 'view_csv',
  VIEW_EXCEL: 'view_excel',
  VIEW_IMAGE: 'view_image',
  VIEW_CROSSTAB: 'view_crosstab',
};

export const WORKBOOK_ACTIONS = [
  ACTION_TYPES.WORKBOOK_PDF,
  ACTION_TYPES.WORKBOOK_POWERPOINT,
];

export const ACTION_OPTIONS: IItem[] = [
  {
    label: 'Export Workbook PDF',
    value: ACTION_TYPES.WORKBOOK_PDF,
  },
  {
    label: 'Export Workbook PowerPoint',
    value: ACTION_TYPES.WORKBOOK_POWERPOINT,
  },
  DIVIDER,
  {
    label: 'Export View PDF',
    value: ACTION_TYPES.VIEW_PDF,
  },
  {
    label: 'Export View CSV',
    value: ACTION_TYPES.VIEW_CSV,
  },
  {
    label: 'Export View Excel',
    value: ACTION_TYPES.VIEW_EXCEL,
  },
  {
    label: 'Export View Image',
    value: ACTION_TYPES.VIEW_IMAGE,
  },
  {
    label: 'Export View Crosstab',
    value: ACTION_TYPES.VIEW_CROSSTAB,
  },
];

export const PDF_ORIENTATION_OPTIONS: IItem[] = [
  {
    label: 'Portrait',
    value: 'portrait',
  },
  {
    label: 'Landscape',
    value: 'landscape',
  },
];

export const IMAGE_RESOLUTION_OPTIONS: IItem[] = [
  {
    label: 'Standard',
    value: 'standard',
  },
  {
    label: 'High',
    value: 'high',
  },
];

export const PDF_PAGE_TYPE_OPTIONS: IItem[] = [
  {
    label: 'Legal',
    value: 'legal',
  },
  {
    label: 'A3',
    value: 'a3',
  },
  {
    label: 'A4',
    value: 'a4',
  },
  {
    label: 'A5',
    value: 'a5',
  },
  {
    label: 'B5',
    value: 'b5',
  },
  {
    label: 'Executive',
    value: 'executive',
  },
  {
    label: 'Folio',
    value: 'folio',
  },
  {
    label: 'Ledger',
    value: 'ledger',
  },
  {
    label: 'Letter',
    value: 'letter',
  },
  {
    label: 'Note',
    value: 'note',
  },
  {
    label: 'Quarto',
    value: 'quarto',
  },
  {
    label: 'Tabloid',
    value: 'tabloid',
  },
];

export const tableauContentOptions: TableauContentOptions = {
  ...defaultContentOptions,
  showActions: true, // tableau export actions
  showCustomViews: true,
}

export interface IItem {
  label: string;
  value: string;
}

export const LOCALE: IItem[] = [
  { label: "Unspecified", value: "" },
  { label: "Albanian (Albania)", value: "sq_AL" },
  { label: "Arabic (Algeria)", value: "ar_DZ" },
  { label: "Arabic (Bahrain)", value: "ar_BH" },
  { label: "Arabic (Egypt)", value: "ar_EG" },
  { label: "Arabic (Iraq)", value: "ar_IQ" },
  { label: "Arabic (Jordan)", value: "ar_JO" },
  { label: "Arabic (Kuwait)", value: "ar_KW" },
  { label: "Arabic (Lebanon)", value: "ar_LB" },
  { label: "Arabic (Libya)", value: "ar_LY" },
  { label: "Arabic (Morocco)", value: "ar_MA" },
  { label: "Arabic (Oman)", value: "ar_OM" },
  { label: "Arabic (Qatar)", value: "ar_QA" },
  { label: "Arabic (Saudi Arabia)", value: "ar_SA" },
  { label: "Arabic (Sudan)", value: "ar_SD" },
  { label: "Arabic (Syria)", value: "ar_SY" },
  { label: "Arabic (Tunisia)", value: "ar_TN" },
  { label: "Arabic (U.A.E.)", value: "ar_AE" },
  { label: "Arabic (Yemen)", value: "ar_YE" },
  { label: "Belarusian (Belarus)", value: "be_BY" },
  { label: "Bulgarian (Bulgaria)", value: "bg_BG" },
  { label: "Catalan (Spain)", value: "ca_ES" },
  { label: "Chinese (China)", value: "zh_CN" },
  { label: "Chinese (Hong Kong)", value: "zh_HK" },
  { label: "Chinese (Singapore)", value: "zh_SG" },
  { label: "Chinese (Taiwan)", value: "zh_TW" },
  { label: "Croatian (Croatia)", value: "hr_HR" },
  { label: "Czech (Czech Republic)", value: "cs_CZ" },
  { label: "Danish (Denmark)", value: "da_DK" },
  { label: "Dutch (Belgium)", value: "nl_BE" },
  { label: "Dutch (Netherlands)", value: "nl_NL" },
  { label: "English (Australia)", value: "en_AU" },
  { label: "English (Canada)", value: "en_CA" },
  { label: "English (India)", value: "en_IN" },
  { label: "English (Ireland)", value: "en_IE" },
  { label: "English (Malta)", value: "en_MT" },
  { label: "English (New Zealand)", value: "en_NZ" },
  { label: "English (Philippines)", value: "en_PH" },
  { label: "English (Singapore)", value: "en_SG" },
  { label: "English (South Africa)", value: "en_ZA" },
  { label: "English (United Kingdom)", value: "en_GB" },
  { label: "English (United States)", value: "en_US" },
  { label: "Estonian (Estonia)", value: "et_EE" },
  { label: "Finnish (Finland)", value: "fi_FI" },
  { label: "French (Belgium)", value: "fr_BE" },
  { label: "French (Canada)", value: "fr_CA" },
  { label: "French (France)", value: "fr_FR" },
  { label: "French (Luxembourg)", value: "fr_LU" },
  { label: "French (Switzerland)", value: "fr_CH" },
  { label: "German (Austria)", value: "de_AT" },
  { label: "German (Germany)", value: "de_DE" },
  { label: "German (Luxembourg)", value: "de_LU" },
  { label: "German (Switzerland)", value: "de_CH" },
  { label: "Greek (Cyprus)", value: "el_CY" },
  { label: "Greek (Greece)", value: "el_GR" },
  { label: "Hebrew (Israel)", value: "iw_IL" },
  { label: "Hindi (India)", value: "hi_IN" },
  { label: "Hungarian (Hungary)", value: "hu_HU" },
  { label: "Icelandic (Iceland)", value: "is_IS" },
  { label: "Indonesian (Indonesia)", value: "in_ID" },
  { label: "Italian (Italy)", value: "it_IT" },
  { label: "Italian (Switzerland)", value: "it_CH" },
  { label: "Japanese (Japan)", value: "ja_JP" },
  { label: "Korean (Korea)", value: "ko_KR" },
  { label: "Latvian (Latvia)", value: "lv_LV" },
  { label: "Lithuanian (Lithuania)", value: "lt_LT" },
  { label: "Macedonian (North Macedonia)", value: "mk_MK" },
  { label: "Malay (Malaysia)", value: "ms_MY" },
  { label: "Maltese (Malta)", value: "mt_MT" },
  { label: "Norwegian (Norway)", value: "no_NO" },
  { label: "Polish (Poland)", value: "pl_PL" },
  { label: "Portuguese (Brazil)", value: "pt_BR" },
  { label: "Portuguese (Portugal)", value: "pt_PT" },
  { label: "Romanian (Romania)", value: "ro_RO" },
  { label: "Russian (Russia)", value: "ru_RU" },
  { label: "Serbian (Bosnia and Herzegovina)", value: "sr_BA" },
  { label: "Serbian (Montenegro)", value: "sr_ME" },
  { label: "Serbian (Serbia)", value: "sr_RS" },
  { label: "Slovak (Slovakia)", value: "sk_SK" },
  { label: "Slovenian (Slovenia)", value: "sl_SI" },
  { label: "Spanish (Argentina)", value: "es_AR" },
  { label: "Spanish (Bolivia)", value: "es_BO" },
  { label: "Spanish (Chile)", value: "es_CL" },
  { label: "Spanish (Colombia)", value: "es_CO" },
  { label: "Spanish (Costa Rica)", value: "es_CR" },
  { label: "Spanish (Dominican Republic)", value: "es_DO" },
  { label: "Spanish (Ecuador)", value: "es_EC" },
  { label: "Spanish (El Salvador)", value: "es_SV" },
  { label: "Spanish (Guatemala)", value: "es_GT" },
  { label: "Spanish (Honduras)", value: "es_HN" },
  { label: "Spanish (Mexico)", value: "es_MX" },
  { label: "Spanish (Nicaragua)", value: "es_NI" },
  { label: "Spanish (Panama)", value: "es_PA" },
  { label: "Spanish (Paraguay)", value: "es_PY" },
  { label: "Spanish (Peru)", value: "es_PE" },
  { label: "Spanish (Puerto Rico)", value: "es_PR" },
  { label: "Spanish (Spain)", value: "es_ES" },
  { label: "Spanish (United States)", value: "es_US" },
  { label: "Spanish (Uruguay)", value: "es_UY" },
  { label: "Spanish (Venezuela)", value: "es_VE" },
  { label: "Swedish (Sweden)", value: "sv_SE" },
  { label: "Thai (Thailand)", value: "th_TH" },
  { label: "Turkish (Turkey)", value: "tr_TR" },
  { label: "Ukrainian (Ukraine)", value: "uk_UA" },
  { label: "Vietnamese (Vietnam)", value: "vi_VN" }
];
